import { html, TemplateResult } from 'lit';

// ── Bell ─────────────────────────────────────────────────────────────────────

export interface RenderBellOptions {
  totalUnread: number;
  onBellClick: () => void;
}

export function renderBell(options: RenderBellOptions): TemplateResult {
  const { totalUnread, onBellClick } = options;
  const label = totalUnread > 0
    ? `Notifications — ${totalUnread} unread`
    : 'Notifications';
  const badgeLabel = totalUnread > 99 ? '99+' : String(totalUnread);

  return html`
    <button
      class="bell-button"
      aria-label=${label}
      @click=${onBellClick}
    >
      <!-- Bell SVG icon -->
      <svg
        class="bell-icon"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        aria-hidden="true"
      >
        <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/>
        <path d="M13.73 21a2 2 0 0 1-3.46 0"/>
      </svg>
      ${totalUnread > 0
        ? html`<span class="badge" aria-hidden="true">${badgeLabel}</span>`
        : html``}
    </button>
  `;
}

